import { useDispatch } from "react-redux";
import * as Actions from "../Actions/actions";
import { SummaryConnected } from "./Steps/Confirmation/Summary";
import { Button } from "@powerdiary/components-library/lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";

export const ConfirmedInfo = () => {
    const dispatch = useDispatch();

    return (
        <div className="row">
            <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                <div className="confirmation-box-booked">
                    <div className="row h-100">
                        <div className="col-12 col-md-6 order-2 order-md-1">
                            <SummaryConnected />
                        </div>
                        <div className="col-12 col-md-6 order-1 order-md-2 d-flex flex-column align-items-center justify-content-center">
                            <div className="appointment-booked w-100"></div>
                            <h2 className="appointment-booked-text">Appointment Booked!</h2>
                        </div>
                    </div>
                </div>

                <div className="terms-and-submit-box mt-4 mb-4">
                    <div className="row">
                        <div className="col-12 ml-auto text-right">
                            <Button
                                variant="contained"
                                size="large"
                                type="button"
                                onClick={() => dispatch(Actions.cancel())}
                                startIcon={<FontAwesomeIcon icon={faHome} />}
                            >
                                Return to home
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
